/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pre-op-instructions.reducer';

export const PreOpInstructionsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const preOpInstructionsEntity = useAppSelector(state => state.preOpInstructions.entity);
  const loading = useAppSelector(state => state.preOpInstructions.loading);
  const updating = useAppSelector(state => state.preOpInstructions.updating);
  const updateSuccess = useAppSelector(state => state.preOpInstructions.updateSuccess);

  const handleClose = () => {
    navigate(`/pre-op-instructions${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...preOpInstructionsEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      anaesthesiologist: doctors.find(it => it.id.toString() === values.anaesthesiologist?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...preOpInstructionsEntity,
          surgery: preOpInstructionsEntity?.surgery?.id,
          anaesthesiologist: preOpInstructionsEntity?.anaesthesiologist?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.preOpInstructions.home.createOrEditLabel" data-cy="PreOpInstructionsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.preOpInstructions.home.createOrEditLabel">Create or edit a PreOpInstructions</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pre-op-instructions-id"
                  label={translate('tinyMedicRestApp.preOpInstructions.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.nilByMouthFrom')}
                id="pre-op-instructions-nilByMouthFrom"
                name="nilByMouthFrom"
                data-cy="nilByMouthFrom"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.reserveBloodProducts')}
                id="pre-op-instructions-reserveBloodProducts"
                name="reserveBloodProducts"
                data-cy="reserveBloodProducts"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.preMedications')}
                id="pre-op-instructions-preMedications"
                name="preMedications"
                data-cy="preMedications"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.specificInstructions')}
                id="pre-op-instructions-specificInstructions"
                name="specificInstructions"
                data-cy="specificInstructions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.otherSpecificInstructions')}
                id="pre-op-instructions-otherSpecificInstructions"
                name="otherSpecificInstructions"
                data-cy="otherSpecificInstructions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.active')}
                id="pre-op-instructions-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.cursor')}
                id="pre-op-instructions-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.lastupdated')}
                id="pre-op-instructions-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.microSec')}
                id="pre-op-instructions-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpInstructions.timestampentry')}
                id="pre-op-instructions-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pre-op-instructions-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.preOpInstructions.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-instructions-anaesthesiologist"
                name="anaesthesiologist"
                data-cy="anaesthesiologist"
                label={translate('tinyMedicRestApp.preOpInstructions.anaesthesiologist')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pre-op-instructions" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PreOpInstructionsUpdate;
